import { Image } from "@tiptap/extension-image";

const CustomImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      //   fullWidth: {
      //     default: false,
      //     parseHTML: (element) => element.hasAttribute("data-full-width"),
      //     renderHTML: (attributes) => {
      //       if (attributes.fullWidth) {
      //         return {
      //           "data-full-width": "true",
      //         };
      //       }
      //     },
      //   },
      size: {
        default: "medium",
        parseHTML: (element) => element.getAttribute("data-size") || "medium",
        renderHTML: (attributes) => {
          if (attributes.size && attributes.size !== "medium") {
            return {
              "data-size": attributes.size,
            };
          }
        },
      },
    };
  },
});

export default CustomImage;
